/*
 * Functions for Content Library
 * Template: templates/content_library/index.html
 */

(function (__module__, c3) {
  'use strict';

  const hideClassName = "d-none";
  const showClassName = "show";

  function init() {

    // Set the default value of the checkbox to unchecked
    $('input[name="select_multiple_contents"]').prop("checked", false);

    // By default hide the checkboxes on each card
    $('input[name="selected_contents"]').hide();

    // Initially Hide the Import Contents Button
    $("#import_all_content").hide()

    // Check the value of the input 'content-type' is blueprints
    var typeValue = $('#type').val();

    // Check if type Value is "blueprints"
    if (typeValue === "blueprints") {
        // Show the Import Contents Div
        $('#import-selected-contents').show();
    } else {
        // Hide the Import Contents Div
        $("#import-selected-contents").hide();
    }

    $('input[name="selected_contents"]').change(function() {
      if ($('#select_multiple_contents').is(':checked')) { // Check if "select_multiple_contents" checkbox is checked
          var count = $('input[name="selected_contents"]:checked').length;
          $('#select_multiple_contents_count').text(count);
      }
    });

    $('input[name="selected_contents"]').change(function() {
      if ($('#select_all').is(':checked')) { // Check if "select_all" checkbox is checked
          var count = $('input[name="selected_contents"]:checked').length;
          $('#select_all_contents_count').text(count);
      }
    });


    // Define a function to uncheck all checkboxes
    function uncheckAll() {
        $('input[name="selected_contents"]').prop('checked', false);
        $('#select_multiple_contents_count').text("0");
        $('#select_all_contents_count').text("0");
    }

    // Function that shows Error Modal 
    function showErrorModal(title, message){
      $('#error_modal #error_modal_title').text(title);
      $('#error_modal #error_modal_body').text(message);
      $("#error_modal").addClass("show"); // Add class "show"
      $("#error_modal").css("display", "block"); // Set style to "display:block"
      $("#error_modal").attr("role", "dialog"); // Add role "dialog"
    }


    // Function that hides Error Modal 
    function hideErrorModal(title, message){
      $("#error_modal").removeClass("show"); // Remove class "show"
      $("#error_modal").css("display", "none"); // Set style "display: none"
      $("#error_modal").removeAttr("role"); // Remove role "dialog"
    }

    // Function that validates if atleast one content is selected 
    function validateContentSelection(){
      // If none of the checkbox is selected then throw error message
      if ($('input[name="selected_contents"]:checked').length == 0) {
        //c3.alerts.addGlobalAlert("Select at least 1 content to be imported", "error", true, 15000);
        showErrorModal("Validation Error", "Select at least 1 content to be imported")
        return false;
      }
      return true;
    }

    // Function that shows the modal 
    function showConfirmationModal(){
      $("#import_multi_bp_confirmation_modal").addClass("show"); // Add class "show"
      $("#import_multi_bp_confirmation_modal").css("display", "block"); // Set style to "display:block"
      $("#import_multi_bp_confirmation_modal").attr("role", "dialog"); // Add role "dialog"
    }
    
    // Function that hides the modal 
    function hideConfirmationModal()
    {
      $("#import_multi_bp_confirmation_modal").removeClass("show"); // Remove class "show"
      $("#import_multi_bp_confirmation_modal").css("display", "none"); // Set style "display: none"
      $("#import_multi_bp_confirmation_modal").removeAttr("role"); // Remove role "dialog"
    }

    $('#import_all_content').off('click').on('click', function(event) {
      if (validateContentSelection()) {
        showConfirmationModal();
      }
    });

    // Close the modal when the close button is clicked
    $(".modal-footer .btn-light, .btn-close").off('click').on('click', function(event) {
      hideConfirmationModal();
      hideErrorModal();
    });

    $('#import_all_content_confirmation').off('click').on('click', function(event) {
      event.preventDefault();  // Prevent default form submission
      var selectedChoices = [];
      $('input[name="selected_contents"]:checked').each(function() {
        var jsonString = $(this).val();
        selectedChoices.push(jsonString);
      });

      // Convert the array of selected choices to JSON string
      var jsonString = JSON.stringify(selectedChoices);

      // Uncheck all selected contents 
      uncheckAll();

      // Access the CSRF token
      var csrfToken = document.getElementsByName('csrfmiddlewaretoken')[0].value;
      $.ajax({
        url: "/catalog/library/import_multiple_blueprint_from_content_library", // URL endpoint for the AJAX request
        method: 'POST',
        headers: {
          "X-CSRFToken": csrfToken  // Set the CSRF token in the request header
        },
        data: {'choices': jsonString},  // Send selected choices as JSON array
        success: function(response) {
            if (response["success"]){
                var job_title = response["success"];
                // Fetch the Job ID from the job title
                var job_id = parseInt(job_title.match(/\d+/)[0]);          
                if (job_id){
                  // Redirect to another page to create proper notification
                  window.location.href = "/catalog/notification_display?job_id="+job_id;
                }      
            }
            if (response["error"])
            {
                var message = response["error"];
                // Hide Current Confirmation Modal
                hideConfirmationModal();
                // Show the error modal loaded with mentioned Title and Message
                showErrorModal("Permission Error", message);
            }
            return
        }
      });
    });

    // JavaScript for select all functionality
    document.getElementById('select_all').addEventListener('change', function() {

      // Show Hidden Import Contents Button only Which Multiple Option is selected
      $("#import_all_content").show()

      var checkboxes = document.getElementsByName('selected_contents');
      for (var i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = this.checked;
      }


      if($(this).is(":checked")) {
          // Assign Initial Checked Counts
          var count = $('input[name="selected_contents"]:checked').length;
          $('#select_all_contents_count').text(count);

          // Disable Single Content Download Button on Each Content
          $('[name="import_contents"]').addClass('disabled');

          // Disable Multiple Selected Checkbox
          $('#select_multiple_contents').prop('disabled', true);


          // Show checkboxes with name "selected_contents"
          $('input[name="selected_contents"]').show();

          // Remove stretched-link class from a tag
          $("a.card-link").removeClass("stretched-link")
      }
      else
      {
          // Reset Select All Count to Zero 
          $('#select_all_contents_count').text("0");

          // Enable Single Content Download Button on Each Content
          $('[name="import_contents"]').removeClass('disabled');

          // Hide checkboxes with name "selected_contents"
          $('input[name="selected_contents"]').hide();

          // Enable Multiple Selected Checkbox
          $('#select_multiple_contents').prop('disabled', false);

          // Remove stretched-link class to a tag
          $("a.card-link").addClass("stretched-link")

          // Hide Import Contents Button
          $("#import_all_content").hide()
      }
    });

    var checkboxes = document.getElementsByName('selected_contents');
    for (var i = 0; i < checkboxes.length; i++) {
      checkboxes[i].addEventListener('change', function() {
          var allChecked = true;
          for (var j = 0; j < checkboxes.length; j++) {
              if (!checkboxes[j].checked) {
                  allChecked = false;
                  break;
              }
          }
          document.getElementById('select_all').checked = allChecked;
      });
    }

    $('#select_multiple_contents').change(function() {
      if($(this).is(":checked")) {
          // Disable Single Content Download Button on Each Content
          $('[name="import_contents"]').addClass('disabled');

          // Show checkboxes with name "selected_contents"
          $('input[name="selected_contents"]').show();

          // Disable checkbox for id 'select_all'
          $('#select_all').prop('disabled', true);

          // Remove stretched-link class from a tag
          $("a.card-link").removeClass("stretched-link")

          // Show Import Contents Button
          $("#import_all_content").show()
      } else {

          // Reset Select All Count to Zero 
          $('#select_multiple_contents_count').text("0");

          // Enable Single Content Download Button on Each Content
          $('[name="import_contents"]').removeClass('disabled');

          // Hide checkboxes with name "selected_contents"
          $('input[name="selected_contents"]').hide();

          // Enable checkbox for id 'select_all'
          $('#select_all').prop('disabled', false);

          // Add stretched-link class to a tag
          $("a.card-link").addClass("stretched-link")

          // Hide Import Contents Button
          $("#import_all_content").hide()
      }
    });
    
    $("#search_box").change(function () {
      c3.library.setUrlQuery();
    });
    // Allows custom input search when pressing enter
    $("#search_box").submit(function (e) {
      e.preventDefault()
      c3.library.setUrlQuery();
    });
    // Allows custom input search when escaping the search input
    $('#id_searchbar-selectized').on('keydown.searchBindings', function(e) {
      if (e.key == 'Escape') {
        e.preventDefault()
        e.currentTarget.blur()
        if (e.currentTarget.value) {
          c3.library.setUrlQuery()
        } else {
        $("#search_box div.selectize-input").removeClass('focus input-active')
        }
      }
    })
  }

  function setContentType(type) {
    $("#type").val(type);
    c3.library.setUrlQuery();
  }

  function showContent() {
    $("#content-cards").addClass(showClassName).removeClass(hideClassName);
  }

  function setUrlQuery() {
    $("#content-cards").addClass(hideClassName).removeClass(showClassName);
    $("#no-content-cards").addClass(hideClassName).removeClass(showClassName);
    c3.spinners.showSpinner();
    const encodedSort = encodeURI($('#sortBySelect option:selected').val())
    const searchParams = new URLSearchParams(encodedSort);
    searchParams.set("type", encodeURI($("#type").val()));
    // the below variable was discovered by using inspect element on the rendered page
    // turns out that the selectized item is in fact saved as a div element that we can reach
    const searchElement = document.getElementById("search_box");
    const autoCompletedValue = searchElement.getElementsByClassName("item")[0];
    const userInputValue = $("#id_searchbar-selectized")[0];
    let searchTerm
    if (autoCompletedValue && autoCompletedValue?.dataset?.value) {
      searchTerm = `${autoCompletedValue.dataset.value}`
    }
    if (userInputValue && userInputValue?.value) {
      searchTerm = `${userInputValue.value}`
    }
    if (searchTerm != '' && searchTerm != undefined) {
      searchParams.set("search", `${searchTerm}`);
    }
    window.location = `?${searchParams.toString()}`;
  }

  c3[__module__] = {
    init: init,
    setUrlQuery: setUrlQuery,
    setContentType: setContentType,
    showContent: showContent
  };
})('library', window.c3);
